
import photoClient from '~/clients/photoClient';

export default {
    name: 'NetworkImage',
    methods: {
        onImgLoad() {
            this.showLoader = false;
        },
    },
    props: {
        image: Object,
        width: Number,
        height: Number,
        original: Boolean,
    },
    data() {
        return {
            showLoader: true,
        };
    },
    computed: {
        imageExists() {
            return this.image && this.image.urlTemplate;
        },
        src() {
            if (this.original) {
                return photoClient.getURL({ template: this.image.urlTemplate, original: true });
            }

            return photoClient.getURL({ template: this.image.urlTemplate, width: this.width, height: this.height });
        },
    },
};
